import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Login from "../Components/Login/Login";
import RequestPasswordChange from "../Components/RequestPasswordReset/RequestPasswordReset";
import ChangePassword from "../Components/ResetPassword/ResetPassword";
import BaseUrl from "../Stores/DataStore/Enums/BaseUrl";

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loginTypes: this.props.stores.data.Enums.LoginPageTypes,
      shownComponent: this.props.stores.data.Enums.LoginPageTypes.LOGIN.Name
    };
  }

  onRefreshComponent(componentToShow) {
    const baseUrl = new BaseUrl();
    window.location.assign(`${baseUrl.BROWSERURL}#${componentToShow}`);
    this.setState({ shownComponent: componentToShow });
  }

  render() {
    const stringParts = window.location.hash.split("?");
    const shownComponent = stringParts[0].substring(1, stringParts[0].length);
    let component = (
      <Login
        onLoginStatusChanged={this.props.onLoginStatusChanged}
        onRefreshComponent={this.onRefreshComponent.bind(this)}
        loginTypes={this.state.loginTypes}
      />
    );

    if (shownComponent === this.state.loginTypes.REQUESTPASSWORDRESET.Name) {
      component = <RequestPasswordChange onRefreshComponent={this.onRefreshComponent.bind(this)} loginTypes={this.state.loginTypes} />;
    } else if (shownComponent === this.state.loginTypes.RESETPASSWORD.Name) {
      component = <ChangePassword onRefreshComponent={this.onRefreshComponent.bind(this)} loginTypes={this.state.loginTypes} />;
    }

    return <div className="login">{component}</div>;
  }
}

export default inject("stores")(observer(LoginPage));



// WEBPACK FOOTER //
// ./src/Pages/LoginPage.js